<template lang="pug">
.index(
  :style="{height: height}")
  b-header
  .next.mobi(@click="turnTop",v-if="currentPage !==0") &#xe71a;
  .next.mobi(@click="turnNext",v-if="currentPage ===0") &#xe608;
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel.prevent="mousewheel",
    @wheel.prevent="mousewheel")
    .page.page_home(:style="{height: height}")
      transition(name="left-in")
        .title(v-show="animateCtrl[0]") {{langs[lang].bannerTitle1}}
          br
          .main {{langs[lang].bannerTitle2}}
      banner.banner(
        ref="banner",
        :imgs="banner")
      page.navigation(
        ref="banner_navigation"
        @prev="bannerPrev",
        @next="bannerNext",
        :total="3")
      transition(name="top-in")
        img.mouse.pc(
          v-show="animateCtrl[0]",
          :src="require('../assets/mouse.png')"
          )
      timeline.timeline.pc(
        ref="banner_timeline",
        v-show="currentPage === 0",
        @reset="banner_resetTime",
        :percent="indexTime")
    .page.page_contact(:style="{height: height}")
      transition(name="left-in")
        .content(v-show="animateCtrl[1]")
          .title(@click="$router.push('/contact')") {{langs[lang].contact}}
          transition(name="bottom-in-delay")
            .template(v-show="animateCtrl[1]")
              .city(@click="switchCity('beijing')") {{langs[lang].beijing}}
              .detail(v-show="isMobi || showingCity == 'beijing'")
                p +86 10 6563 0026
                p  {{langs[lang].addressBeijing}}
              .city(@click="switchCity('shanghai')") {{langs[lang].shanghai}}
              .detail(v-show="isMobi || showingCity == 'shanghai'")
                p +86 21 6418 7585
                p  {{langs[lang].addressShanghai}}
      transition(name="right-in")
        #map
      a.c2(href="http://www.beian.miit.gov.cn") 京ICP备13001817号-4
      .c © 2022贝塔斯曼亚洲投资基金 ALL RIGHTS RESERVED
</template>

<script>
import header from "./header";
import timeline from "./timeline";
import banner from "./banner";
import slider from "./slider";
import page from "./page";
import fanpage from "../mixin/fanpage.js";
const Index = {
  mixins: [fanpage],
  props: [],
  data() {
    return {
      opts: {
        der: 0.2,
      },
      langs: {
        en: {
          bannerTitle1: "Bertelsmann Asia Investments",
          bannerTitle2: "Empower Future Business Leaders",
          aboutTItle1: "About BAI",
          aboutDetail1:
            "Bertelsmann’s investment arm in idea of creating better history with first movers.",
          aboutTItle2: "About Betafund",
          aboutDetail2:
            "about Betafund: an angel fund supporting entrepreneurs who dream what they want to dream.",
          aboutTItle3: "About Bertelsmann",
          aboutDetail3:
            "about Bertelsmann: an international media, services and education company.",
          portfolio: "PORTFOLIO",
          list: "LIST",
          companyTitle1: ">3 Billion",
          companydetail1: "Asset Under Management",
          companyTitle2: ">160",
          companydetail2: "Invested startups",
          companyTitle3: "> 500 Million",
          companydetail3: "Combined DAU",
          companyTitle4: ">140 Billion",
          companydetail4: "Combined Market Cap",
          teamTitle: "OUR TEAM",
          teamDetail1: "INVESTMENT",
          teamDetail2: "AS A SERVICE",
          news: "NEWS",
          contact: "CONTACT US",
          service: "Services",
          more: "More Bertelsmann",
          network: "Bertelsmann Network",
          join: "Join Us",
          bp: "BP",
          index_1: "ABOUT BAI",
          index_2: "OUR BELIEF",
          index_3: "PORTFOLIO",
          index_4: "OUR TEAM",
          index_5: "NEWS",
          index_6: "CONTACT US",
          baiChina: "Bertelsmann China Corporate Center",
          baiSE: "Bertelsmann SE& Co.KGaA",
          addressBeijing:
            "Unit 1609, 16F, West Tower, Genesis Beijing, 8 Xinyuan South Rd., Chaoyang District",
          postBeijing: "Beijing 100027, P.R.China",
          addressShanghai: "4F, 750 Yongjia Rd.",
          postShanghai: "Shanghai 200031, PR China",
          beijing: "BEIJING",
          shanghai: "SHANGHAI",
        },
        zh: {
          bannerTitle1: "贝塔斯曼亚洲投资基金",
          bannerTitle2: "成就未来商业领袖",
          aboutTItle1: "关于 BAI",
          aboutDetail1: "与先行者推动更好的历史",
          aboutTItle2: "关于BAI梦想基金",
          aboutDetail2: "支持“敢想敢做”的创业者",
          aboutTItle3: "关于贝塔斯曼集团",
          aboutDetail3: "国际领先的传媒、教育、服务巨擘",
          portfolio: "被投企业",
          list: "列表",
          companyTitle1: ">30亿美金 ",
          companydetail1: "管理资金规模",
          companyTitle2: ">160",
          companydetail2: "投资公司数量",
          companyTitle3: ">5亿人次",
          companydetail3: "所提供的服务每月触及",
          companyTitle4: ">1400亿美金",
          companydetail4: "投资公司市值总和",
          teamTitle: "我们的团队",
          teamDetail1: "投资",
          teamDetail2: "即服务",
          news: "新闻",
          contact: "联系我们",
          service: "服务",
          more: "更多贝塔斯曼",
          network: "贝塔斯曼网络",
          join: "加入我们",
          bp: "商业计划书",
          index_1: "关于",
          index_2: "理念",
          index_3: "投资",
          index_4: "团队",
          index_5: "动态",
          index_6: "联系",
          baiChina: "贝塔斯曼中国总部",
          baiSE: "贝塔斯曼集团总部",
          addressBeijing: "北京市朝阳区新源南路8号启皓北京西塔16层1609室",
          postBeijing: "邮编100027",
          addressShanghai: "上海市徐汇区永嘉路750号4楼",
          postShanghai: "邮编200031",
          beijing: "北京",
          shanghai: "上海",
        },
      },
      showNews: 0,
      indexTime: 0,
      banner: [
        {
          img: require("../assets/BANNER/banner_1.jpg"),
        },
        {
          img: require("../assets/BANNER/banner_2.jpg"),
        },
        {
          img: require("../assets/BANNER/banner_3.jpg"),
        },
      ],
      showingCity: "",
      map: null,
      totalPage: 1,
      newsList: [],
      teamList: [],
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    // this.getNews();
    // this.getTeam();
    this.map = new window.AMap.Map("map", {
      center: [116.4561, 36.9476],
      scrollWheel: false,
      zoom: 4,
    });
    this.markers = [
      new window.AMap.Marker({
        position: [116.4561, 39.9476],
        offset: new window.AMap.Pixel(-12, -12),
        map: this.map,
      }),
      new window.AMap.Marker({
        position: [121.446711, 31.204105],
        offset: new window.AMap.Pixel(-12, -12),
        map: this.map,
      }),
    ];
    setTimeout(() => {
      this.animateCtrl = [1];
      this.map.addControl(new window.AMap.ToolBar());
    }, 10);
  },
  components: {
    bHeader: header,
    timeline,
    banner,
    page,
    slider,
  },
  computed: {
    lang() {
      return localStorage.lang;
    },
    showFooter() {
      var docEl = document.documentElement;
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return "hidden";
      let remSize = 20 * (clientWidth / 320);
      return parseFloat(this.height) > remSize * 8.5;
    },
    isMobi() {
      return window.isMobi;
    },
  },
  methods: {
    getNews() {
      var lang = "";
      if (this.lang === "zh") {
        lang = 54;
      } else {
        lang = 56;
      }
      window.$http
        .get(
          window.hostName + `wp-json/wp/v2/news?page=1&per_page=3&tags=${lang}`
        )
        .then((res) => {
          this.newsList = res.data.map((item) => {
            return {
              img: item.image.guid,
              title: item.title.rendered,
              content: item.content.rendered,
              link: item.link,
            };
          });
        });
    },
    getTeam() {
      window.$http
        .get(window.hostName + `wp-json/wp/v2/index_team?page=1&per_page=3`)
        .then((res) => {
          this.teamList = res.data.map((item) => {
            return {
              title: item.title.rendered,
              content: item.content.rendered.match(/http(.*?)(jpg|png)/)[0],
            };
          });
        });
    },
    openLink(link) {
      window.open(link);
    },
    switchCity(city) {
      this.showingCity = city;
      var options = {
        beijing: new window.AMap.LngLat(116.4561, 39.9476),
        shanghai: new window.AMap.LngLat(121.446711, 31.204105),
      };
      this.map.setCenter(options[this.showingCity]);
      this.map.setZoom(16);
      this.turnTo(1);
    },
    showRight() {
      this.$refs.rightbar.show = true;
    },
    banner_resetTime() {
      this.$refs.banner.next();
      this.$refs.banner_navigation.auto();
    },
    bannerPrev() {
      this.$refs.banner.prev();
      this.$refs.banner_timeline.reset();
    },
    bannerNext() {
      this.$refs.banner.next();
      this.$refs.banner_timeline.reset();
    },
    news_resetTime() {
      this.nextNews();
      // this.$refs.news_navigation.auto()
    },
    newsPrev() {
      if (this.showNews > 0) {
        this.showNews--;
      } else {
        this.showNews = this.newsList.length - 1;
      }
      this.$refs.news_timeline.reset();
    },
    newsNext() {
      this.nextNews();
    },
    nextNews() {
      if (this.showNews < this.newsList.length - 1) {
        this.showNews++;
      } else {
        this.showNews = 0;
      }
      this.$refs.news_timeline.reset();
    },
    turnTop() {
      this.turnTo(0);
    },
    turnNext() {
      this.turnTo(1);
    },
  },
};
export default Index;
</script>

<style scoped lang="stylus">
@import '../common.styl'
@media (max-width: 720px) {
  .next{
    font-family: iconfont;
    position: fixed;
    font-size: 40px;/*no*/
    color: #aaa
    bottom: 100px;
    width: 40px;/*no*/
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 999;
  }
  .page{
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    .title{
      margin-top: 444px;
      color: #002b69;
      font-size: 36px;/*no*/
      font-weight: bold;
      display: inline-block;
      margin-right: 25px;
      cursor: pointer;
    }
    .subtitle{
      display: inline-block;
      position: relative;
      top: 0px;
      left: 8px;
      font-size: 16px;/*no*/
      font-weight: bold;
      color: #e50027;
    }
  }
  .page_home{
    .title{
      position: absolute;
      margin: 0;
      transform: translate(-50%, -50%);
      top: 45%;
      left: 50%;
      z-index: 90;
      color: #fff;
      width: 100%;
      text-align: center;
      font-size: 150px;
      font-weight: bold;
    }
    .timeline{
      width: 100%;
      position: fixed;
      bottom: 32px;
    }
    .mouse{
      position: fixed;
      left: 50%;
      height: 100px;
      transform: translateX(-50%);
      bottom: 40px;
    }
    .navigation{
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 500px;
      font-size: 12px;/*no*/
      height: 12px;/*no*/
    }
  }
  .page_about{
    background: url('../assets/header_bg.jpg') left top / 200%;
    padding-left: 120px;
    .title{
      margin-top: 300px;
      margin-left: 0;
      color: #002b69;
      display: block;
      color: #fff;
      line-height: 1.5;
    }
    .logo{
      margin: 50px 0 50px 0;
      height: 120px;
    }
    .item{
      position: relative;
      margin-bottom: 108px;
      .title{
        font-size: 14px;/*no*/
        color: #fff;
        font-weight: normal;
        margin-top: 0;
        margin-left: 84px;
      }
      .icon{
        position: absolute;
        top: 35px;
        left: 8px;
        width: 52px;
        height: 46px;
      }
      p{
        color: #fff;
        margin: 0;
        width: 99%;
        font-size: 12px;/*no*/
      }
    }
    .about_img{
      position: absolute;
      right: 0;
      bottom: 0;
      height: 30%;
      width: 100%;
      background: #fff;
      img{
        float: left;
        width: 50%;
        margin-top: 10%;
      }
    }
  }
  .page_portfolio{
    .title{
      margin-top: 300px;
      margin-left: 120px;
    }
    .slider{
      margin-top: 100px;
    }
  }
  .page_companies{
    .icons{
      margin: 500px auto;
      width: 100%;
      .icon{
        position: relative;
        padding: 0px 0 250px 0;
        height: 900px;
        width: 50%;
        text-align: center;
        float: left;
        img{
          width: 800px;
          vertical-align: bottom;
        }
        .title{
          position: absolute;
          left: 0;
          bottom: 150px;
          font-size: 120px;
          text-align: center;
          color: #002b69;
          margin: 0;
          width: 100%;
        }
        .desc{
          font-size: 10px;/*no*/
          color: #002b69;
          font-weight: bold;
          position: absolute;
          bottom: 0px
          left: 0;
          text-align: center;
          margin: 0;
          width: 100%;
        }
      }
    }
    .more{
      cursor: pointer;
      width: 100px;/*no*/
      position: absolute;
      right: 80px;
      bottom: 180px;
    }
  }
  .page_team{
    .title{
      margin-top: 300px;
      margin-left: 120px;
    }
    .fll{
      float: left;
    }
    .imgs{
      margin-top: 50px;
      cursor: pointer;
    }
    .img_big{
      display: block;
      width: 100%;
    }
    .img_small{
      .img{
        width: 50%;
        float: left;
        display: block;
      }
    }
    img{
      filter: grayscale(100%);
      filter: gray;
      transition: all .5s;
      &:hover{
        filter: grayscale(0%);
        filter: transparent;
      }
    }
    .about{
      display: none;
      padding: 50px 80px;
      float: left;
      background: url('../assets/bg_blue.png') center / cover;
      width: 650px;
      height: 528px;
      color: #fff;
      font-size: 50px;
      font-weight: bold;
    }
  }
  .page_news{
    .title{
      margin-top: 300px;
    }
    .news{
      width: 100%;
      height: 80%;
      position: absolute;
      top: 550px;
      .text{
        padding: 150px 200px;
        width: 100%;
        min-height: 900px;
        background: url('../assets/bg_blue.png') center / 200%;
      }
      .news_cover{
        cursor: pointer;
        position: absolute;
        width: 100%;
      }
      .post_title{
        color: #fff;
        font-size: 20px;/*no*/
        line-height: 1.5;
      }
      .post_content{
        color: #fff;
        font-size: 10px;/*no*/

        margin-top: 50px;
        line-height: 1.5;
        height: 600px;
        max-height: 600px;
      }
      .img{
        position: absolute;
        left: 0;
        bottom: -900px;
        height: 900px;
        width: 100%;
        background-position: center!important;
      }
      .next{
        display: none;
        width: 76px;
        height: 151px;
        position: absolute;
        top: 300px;
        right: 100px;
      }
      .timeline{
        display: none;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .navigation{
        position: absolute;
        bottom: 200px;
        right: 100px;
        color: #002b69;
        font-size: 14px;/*no*/
      }
    }
  }
  .page_contact{
    background: url('../assets/header_bg.jpg') center / 200%;
    .content{
      width: 100%;
      height: 100%;
      padding-left: 120px;
      .title{
        margin-top: 300px;
      }
    }
    .title{
      color: #fff;
      margin: 0;
    }
    .city{
      color: #e50027;
      font-size: 100px;
      font-weight: bold;
      cursor: pointer;
      margin-top: 60px;
    }
    .detail{
      color: #fff;
      width: 80%;
      font-size: 20px;/*no*/
      margin-top: 10px;
      height: 502.4px;
      p{
        margin: 0;
        line-height: 1.5;
      }
    }
    #map{
      width: 100%;
      height: 1400px;
      position: absolute;
      transform: translate(0, 0);
      right: 0;
      bottom: 0;
      z-index: 9999;
    }
  }
}
@media (min-width: 720px) {
  .page{
    position: relative;
    overflow: hidden;
    width: 100%;
    .title{
      margin-top: 126px;
      margin-left: 68px;
      color: #002b69;
      font-size: 120px;
      font-weight: bold;
      display: inline-block;
      margin-right: 25px;
      cursor: pointer;
    }
    .subtitle{
      display: inline-block;
      position: relative;
      top: 5px;
      left: 8px;
      font-size: 42px;
      font-weight: bold;
      color: #e50027;
    }
  }
  .page_home{
    .title{
      position: absolute;
      z-index: 90;
      color: #fff;
      top: 150px;
      left: 100px;
      font-size: 36px;
      width: 1200px;
      font-weight: normal;
      // text-shadow: 1px 1px 0 #007bbb;
      .main{
        margin-top: 80px;
        font-size: 120px;
      }
    }
    .timeline{
      width: 100%;
      position: absolute;
      bottom: 32px;
    }
    .mouse{
      position: absolute;
      left: 50%;
      height: 100px;
      bottom: 38px;
    }
    .navigation{
      bottom: 70px;
      right: 100px;
      font-size: 24px;
      height: 24px;
    }
  }
  .page_about{
    background: url('../assets/bg_blue.png') left top / 1180px auto no-repeat;
    padding-left: 76px;
    padding-top: 144px;
    .title{
      margin-top: 0;
      margin-left: 0;
      color: #002b69;
      display: block;
      color: #fff;
      line-height: 1.5;
    }
    .logo{
      margin-top: 30px;
      margin-bottom: 30px;
      height: 64px;
    }
    .item{
      position: relative;
      margin-bottom: 54px;
      &.en{
        margin-bottom: 27px;
      }
      .title{
        font-size: 36px;
        color: #fff;
        font-weight: normal;
        margin-top: 0;
        margin-left: 42px;
      }
      .icon{
        position: absolute;
        top: 15px;
        left: 8px;
        width: 26px;
        height: 23px;
      }
      p{
        color: #fff;
        margin-left: 40px;
        width: 440px;
        font-size: 19px;
        margin: 10px 0 0 40px;
      }
    }
    .about_img{
      position: absolute;
      right: 0;
      top: 324px;
      width: 1095px;
      background: url('../assets/header_bg.jpg') left top / 1180px auto;
      img{
        float: right;
        width: 740px;
        height: 484px;
      }
    }
  }
  .page_portfolio{
    .slider{
      position: absolute;
      bottom: 250px;
    }
  }
  .page_companies{
    .icons{
      margin-top: 80px;
      width: 1000px;
      margin-left: 460px;
      .icon{
        position: relative;
        padding: 0px 0 250px 0;
        height: 420px;
        width: 499px;
        text-align: center;
        float: left;
        img{
          width: 400px;
          vertical-align: bottom;
        }
        .title{
          position: absolute;
          left: 0;
          bottom: 50px;
          font-size: 60px;
          text-align: center;
          color: #002b69;
          margin: 0;
          width: 500px;
          cursor: auto;
        }
        .desc{
          font-size: 24px;
          color: #002b69;
          font-weight: bold;
          position: absolute;
          bottom: 0;
          left: 50px;
          text-align: center;
          margin: 0;
          width: 400px;
        }
      }
    }
    .more{
      cursor: pointer;
      width: 200px;
      position: absolute;
      right: 80px;
      bottom: 140px;
    }
  }
  .page_team{
    .fll{
      float: left;
    }
    .imgs{
      margin-top: 50px;
      cursor: pointer;
    }
    .img_big{
      display: block;
      width: 700px;
      height: 528px;
    }
    .img_small{
      width: 483px;
      .img{
        height: 264px;
        display: block;
      }
    }
    img{
      filter: grayscale(100%);
      filter: gray;
      transition: all .5s;
      &:hover{
        filter: grayscale(0%);
        filter: transparent;
      }
    }
    .about{
      padding: 50px 80px;
      float: left;
      background: url('../assets/bg_blue.png') center / cover;
      width: 650px;
      height: 528px;
      color: #fff;
      font-size: 50px;
      font-weight: bold;
    }
  }
  .page_news{
    .news{
      width: 1180px;
      height: 735px;
      padding: 175px 300px 0 300px;
      position: absolute;
      right: 0;
      top: 200px;
      background: url('../assets/bg_blue.png') center / cover;
      .news_cover{
        cursor: pointer;
        position: absolute;
        width: 75%;
      }
      .text{
        width: 70%;
      }
      .post_title{
        color: #fff;
        font-size: 36px;
        line-height: 1.5;
        margin-bottom: 20px;
      }
      .post_content{
        color: #fff;
        font-size: 18px;
        line-height: 1.5;
      }
      .img{
        position: absolute;
        top: -50px;
        left: -800px;
        width: 700px;
        height: 465px;
      }
      .next{
        width: 76px;
        height: 151px;
        position: absolute;
        top: 100px;
        right: 70px;
      }
      .timeline{
        width: 100%;
        position: absolute;
        left: 0;
        bottom: -2px;
      }
    }
    .navigation{
      position: absolute;
      bottom: 0;
      left: -150px;
      color: #000;
      font-size: 30px;
      height: 30px;
      bottom: 10px;
    }
  }
  .page_contact{
    .content{
      width: 1015px;
      height: 670px;
      padding-left: 45px;
      padding-top: 5px;
      position: absolute;
      left: 0;
      top: 120px;
      background: url('../assets/bg_blue.png') center / cover;
    }
    .title{
      color: #fff;
      margin: 0;
      margin-left: 23px;
      margin-bottom: 100px;
    }
    .city{
      color: #e50027;
      font-size: 50px;
      margin-left: 23px;
      margin-top: 30px;
      cursor: pointer;
    }
    .detail{
      color: #fff;
      font-size: 21px;
      margin-left: 23px;
      margin-top: 10px;
      height: 63px;
      width: 750px;
      p{
        margin: 0;
        line-height: 1.5;
      }
    }
    #map{
      width: 905px;
      height: 427px;
      position: absolute;
      right: 0;
      top: 363px;
    }
    footer{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 200px;
      font-size: 16px;
      color: #21262c;
      padding-left: 45px;
      box-sizing: border-box;
    }
    .c{
      opacity: .4;
      position: absolute;
      bottom: 35px;
      font-size: 12px;
      left: 50%;
      transform: translateX(-50%);
    }
    .c2{
      opacity: .4;
      position: absolute;
      bottom: 15px;
      font-size: 12px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?cc9dbf68